import React from "react";
import { Link, Route, Router, Switch } from "react-router-dom";
import AppConfig from "../../config/app.config";
import { history } from "../../history";
import ExemploFilaAssinatura from "./ExemploFilaAssinatura/ExemploFilaAssinatura";
import ExemploFormatters from "./ExemploFormatters/ExemploFormatters";
import ExemploFormSimples from "./ExemploFormik/ExemploFormSimples";
import ExemploApiClient from "./ExemploHooksApiClient/ExemploApiClient";
import ExemploRedux from "./ExemploRedux/ExemploRedux";
import ExemploUseEffect from "./ExemploUseEffect/ExemploUseEffect";

const Exemplos = () => (
  <div style={{ backgroundColor: "white", padding: "24px" }}>
    <h1>Wiki</h1>
    <h3>Exemplos com as melhores práticas e diferentes componentes e cenários comuns no e-FIS</h3>
    <div>
      <ul>
        <li>
          <Link to="/wiki/api-client">API Client</Link>
        </li>
        <li>
          <Link to="/wiki/form-simples">Formik + Yup</Link>
        </li>
        <li>
          <Link to="/wiki/formatters">Formatters</Link>
        </li>
        <li>
          <Link to="/wiki/useeffect">Hook useEffect()</Link>
        </li>
        <li>
          <Link to="/wiki/assinatura">Fila Assinatura</Link>
        </li>
        <li>
          <Link to="/wiki/redux">Redux + Redux Toolkit</Link>
        </li>
      </ul>
    </div>
    <hr />
    <Router history={history}>
      <Switch>
        {/* Wiki de exemplos e referências de boas práticas */}
        {["dev", "hom"].indexOf(AppConfig.env) !== -1 && (
          <>
            <Route exact path="/wiki/form-simples" component={ExemploFormSimples} />
            <Route exact path="/wiki/api-client" component={ExemploApiClient} />
            <Route exact path="/wiki/formatters" component={ExemploFormatters} />
            <Route exact path="/wiki/useeffect" component={ExemploUseEffect} />
            <Route exact path="/wiki/assinatura" component={ExemploFilaAssinatura} />
            <Route exact path="/wiki/redux" component={ExemploRedux} />
          </>
        )}
      </Switch>
    </Router>
  </div>
);

export default Exemplos;
